import './styles/index.css';
import { api } from './api/vykoClient';
import { Dashboard } from './components/Dashboard';
import { LoginModal } from './components/LoginModal';
import { AdminPanel } from './components/AdminPanel';
import { BypassLoginView } from './components/BypassLoginView';
import { appLogger } from './utils/logger';
import { initTheme } from './utils/theme';
import { initPerformanceMode } from './utils/performance';

// Initialize dark/light mode and hardware performance profile immediately before DOM mount
initTheme();
initPerformanceMode();

let currentView: { destroy?: () => void } | null = null;

function renderRoute() {
  const root = document.getElementById('app');
  if (!root) {
    console.error('Root element #app not found');
    return;
  }

  // Clean up any existing view
  if (currentView?.destroy) {
    currentView.destroy();
    currentView = null;
  }

  const rawPath = window.location.pathname;
  const normalizedPath = rawPath.toLowerCase().replace(/\/$/, '') || '/';

  // 1. Admin route: /admin
  if (normalizedPath === '/admin') {
    appLogger.info('Routing to Admin Panel (/admin)');
    currentView = new AdminPanel(root);
    return;
  }

  // 2. Bypass login route: /BypassLogin or /bypasslogin
  if (normalizedPath === '/bypasslogin') {
    appLogger.info('Routing to Bypass Login (/BypassLogin)');
    currentView = new BypassLoginView(root, () => {
      window.history.pushState({}, '', '/');
      renderRoute();
    });
    return;
  }

  // 3. Default route: Nurse Desk
  function showDashboard() {
    if (currentView?.destroy) currentView.destroy();
    currentView = new Dashboard(root!, () => {
      showLogin();
    });
  }

  function showLogin() {
    if (currentView?.destroy) currentView.destroy();
    currentView = new LoginModal(root!, () => {
      showDashboard();
    });
  }

  if (api.isAuthenticated()) {
    appLogger.info(`Restored session for nurse: ${api.loginId}`);
    showDashboard();
  } else {
    showLogin();
  }
}

function initApp() {
  appLogger.info('Vyko HMS Handover Portal initialized.');
  renderRoute();

  // Listen to browser navigation changes
  window.addEventListener('popstate', () => {
    renderRoute();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}
